<template>
  <div>
    <div class="row coupon flex">
      <div class="col-md-4 col-7 text-left flex">
        <div class="text-content ">
          <div class="row-title">
            <strong>{{ ordersSummary.approvedOrders.count }}</strong>
            Ordenes realizadas
          </div>
          <img src="../assets/Cupon.png" width="15" />
          <span class="text-nowrap faded">
            {{ ordersSummary.approvedOrders.spentCredit }} cupones usados
          </span>
          <br />
        </div>
      </div>
    </div>
    <div class="row coupon flex">
      <div class="col-md-4 col-7 text-left flex">
        <div class="text-content ">
          <div class="row-title">
            <strong>{{ ordersSummary.rejectedOrders.count }}</strong>
            Ordenes canceladas
          </div>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrdersSummary",
  props: ["ordersSummary"],
  created () {
    this.updateOrders()
  },
  data: function() {
    return {
      collapsed: false
    };
  },
  methods: {
    translateStatus: function() {
      let self = this;
      return self.$store.state.translations.state[self.order.status];
    },
    updateOrders: function() {
      this.$Progress.start();
      let url = this.$store.state.connection.url;
      /*
      Why is the POST method being used instead of a GET request?
      the XMLHttpRequest#send method does not send a body when performing
      a GET request, and odoo's json request handling throws a 400 error
      when not specifying a body in json requests.
      */
      this.$http
        .post(url + "orders?state=order", {
          body: {}
        })
        .then(result => {
          this.$Progress.finish();
          this.$store.commit("updateLaundryOrders", result.body.result.orders);
        })
        .catch(err => {
          console.log(err);
          this.$Progress.finish();
        });
    },
  },
};
</script>

<style scoped>
.only-screen {
  margin-top: 10px;
}
.action {
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
  background-color: rgb(94, 158, 203);
  margin-bottom: 3px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 7px;
  margin-right: 5px;
  color: #ffffff;
  min-width: 100px;
}
.sign {
  width: 15px;
  text-align: center;
  color: #ffffff;
  margin-left: 5px;
}
.remove {
  background-color: rgb(221, 47, 0);
}
.action span {
  margin-left: 3px;
}
.action img {
  max-height: 20px;
}
button {
  margin: 4px;
}
svg {
  margin-left: 5px;
  cursor: pointer;
}
.detail {
  margin-top: 4px;
}
.order {
  background-color: rgba(54, 127, 178, 0.1);
  display: flex;
  margin-left: 0px;
  margin-right: 0px;
  margin-top: 4px;
  padding-top: 10px;
  padding-bottom: 10px;
  max-width: 760px;
}
.faded {
  color: rgb(152, 145, 150);
}
.cupon {
  margin-right: 10px;
}
.flex {
  display: flex;
}
.text-content img {
  margin-top: -5px;
  margin-right: 5px;
}
.coupon {
  padding-left: 5%;
  padding-bottom: 5%;
}
.row-title {
  display: flex-inline;
}
</style>
